import { render, staticRenderFns } from "./LabRequests.vue?vue&type=template&id=fc66b11c&scoped=true"
import script from "./LabRequests.vue?vue&type=script&lang=js"
export * from "./LabRequests.vue?vue&type=script&lang=js"
import style0 from "./LabRequests.vue?vue&type=style&index=0&id=fc66b11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc66b11c",
  null
  
)

export default component.exports